import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";

const useIsAdminPage = () => {
    return !!useRouteMatch([
        LinkTo.projectEdit,
        LinkTo.projectCreate,
        LinkTo.profileEdit,
        LinkTo.profileMetrics,
        LinkTo.teamEdit,
        LinkTo.teamCreate,
        LinkTo.teamExternalEdit,
        LinkTo.teamExternalCreate,
        LinkTo.preview,
        LinkTo.ratings,
        LinkTo.metrics,
        LinkTo.teachersMetrics,
        LinkTo.metricsSettings,
        LinkTo.checkHomework,
        LinkTo.previewTeam,
        LinkTo.previewTeamLongread,
        LinkTo.previewTeamLongreadExternal,
        LinkTo.previewExternalTeam,
        LinkTo.competitionEdit,
        LinkTo.competitionCreate,
        LinkTo.competitionAutomaticCreate,
        LinkTo.competitionBriefCreate,
        LinkTo.seasonEdit,
        LinkTo.seasonCreate,
        LinkTo.tagAdmin,
        LinkTo.eduTagAdmin,
        LinkTo.manageTag,
        LinkTo.bindingTag,
        LinkTo.roleAdmin,
        LinkTo.seasonsAdmin,
        LinkTo.competitionsAdmin,
        LinkTo.employeesAdmin,
        LinkTo.teamAdmin,
        LinkTo.tagExpert,
      ]);
};

export default useIsAdminPage;import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";

const useIsAdminPage = () => {
    return !!useRouteMatch([
        LinkTo.projectEdit,
        LinkTo.projectCreate,
        LinkTo.profileEdit,
        LinkTo.profileMetrics,
        LinkTo.teamEdit,
        LinkTo.teamCreate,
        LinkTo.teamExternalEdit,
        LinkTo.teamExternalCreate,
        LinkTo.preview,
        LinkTo.ratings,
        LinkTo.metrics,
        LinkTo.teachersMetrics,
        LinkTo.metricsSettings,
        LinkTo.checkHomework,
        LinkTo.previewTeam,
        LinkTo.previewTeamLongread,
        LinkTo.previewTeamLongreadExternal,
        LinkTo.previewExternalTeam,
        LinkTo.competitionEdit,
        LinkTo.competitionCreate,
        LinkTo.competitionAutomaticCreate,
        LinkTo.competitionBriefCreate,
        LinkTo.seasonEdit,
        LinkTo.seasonCreate,
        LinkTo.tagAdmin,
        LinkTo.eduTagAdmin,
        LinkTo.manageTag,
        LinkTo.bindingTag,
        LinkTo.roleAdmin,
        LinkTo.seasonsAdmin,
        LinkTo.competitionsAdmin,
        LinkTo.employeesAdmin,
        LinkTo.teamAdmin,
        LinkTo.tagExpert,
      ]);
};

export default useIsAdminPage;